import { render, staticRenderFns } from "./PreShipmentsTable.vue?vue&type=template&id=14e8d38c&scoped=true"
import script from "./PreShipmentsTable.vue?vue&type=script&lang=js"
export * from "./PreShipmentsTable.vue?vue&type=script&lang=js"
import style0 from "./PreShipmentsTable.vue?vue&type=style&index=0&id=14e8d38c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e8d38c",
  null
  
)

export default component.exports